module.exports = __webpack_public_path__ + "img/20a-lrn-spt-cat-3-icon-def.a3fa94a1.svg";